/**
 * Created by RUSS_ on 07.05.2018
 */
import { mainChannel, viewChannel } from "../init/message-hub";
import { COOKIE_PREFERENCES, PAGES } from "../const/constants";
import {
  getItem,
  localStorageSupport,
  setItem
} from "../utils/local-storage-util";
import CookieConfig from "../const/default-cookies-config";
import {
  clone,
  convertToConfigFromStorage,
  getConfigAsArrayJson,
  getCookieById,
  getCurrentConfigAsJsonFromList,
  toggleCategory
} from "../utils/cookie-config-helper";
import { optInOut } from "./opt-in-out-manager";
import { listCookies, isEuUser } from "../utils/browser";
import { sameObjects } from "../utils/string-utils";
import { api } from "./api-manager";

export default class CookieManager {
  constructor(data) {
    this.browserData = data;
    this.defaultCookieConfig = CookieConfig.generate();
    this.initEvents();
    this.checkCookies();
  }

  initEvents() {
    mainChannel.reply("acceptCookies", this.acceptCookies, this);
    mainChannel.reply("acceptAllCookies", this.acceptAllCookies, this);
    mainChannel.reply("acceptMinimalCookies", this.acceptMinimalCookies, this);
    mainChannel.reply("acceptCookieById", this.acceptCookieById, this);
    mainChannel.reply(
      "areAllCookiesAccepted",
      this.areAllCookiesAccepted,
      this
    );
    mainChannel.reply("isSomeCookieAccepted", this.isSomeCookieAccepted, this);
    mainChannel.reply("appliedConfig", this.appliedConfig, this);
    mainChannel.reply("applyConfig", this.applyConfig, this);
    mainChannel.reply("toggleCategory", this.toggleCategory, this);
    mainChannel.reply("toggleCookie", this.toggleCookie, this);
    mainChannel.reply("getCookieById", this.getCookieById, this);
    mainChannel.reply(
      "browserData",
      () => {
        return this.browserData;
      },
      this
    );
    api.acceptCookieById = id => {
      this.acceptCookieById(id);
    };
    this.addCookieWatcher();
  }

  checkCookies() {
    const cookieAccepted = getItem(COOKIE_PREFERENCES.COOKIE_ACCEPTED);
    if (!cookieAccepted || cookieAccepted === false) {
      this._readCookieSettings(this.defaultCookieConfig);
      if (isEuUser(this.browserData.country)|| true) {
        viewChannel.request("showPage", PAGES.intro);
      } else {
        viewChannel.request("hide");
        viewChannel.request("togglePreferenceButton", false);
        viewChannel.request("toggleBottomInfo", true);
      }
    } else {
      this._readCookieSettings(
        convertToConfigFromStorage(
          getItem(COOKIE_PREFERENCES.COOKIE_SETTINGS),
          this.defaultCookieConfig
        )
      );
      viewChannel.request("hide");
      if (isEuUser(this.browserData.country)|| true) {
        viewChannel.request("togglePreferenceButton", true);
      }
      console.log("Cookies accepted");
    }
  }

  _readCookieSettings(config) {
    this.cookieConfig = config;
    this.initialConfig = clone(config);
    this.applyCookies();
    console.log("Read initial cookie settings", this.cookieConfig);
  }

  acceptAllCookies() {
    const allCookiesList = this._getCurrentConfigAsJson();
    for (let i = 0; i < allCookiesList.length; i++) {
      allCookiesList[i].accepted = true;
    }
    convertToConfigFromStorage(
      JSON.stringify(allCookiesList),
      this.defaultCookieConfig
    );
    this.acceptCookies();
  }

  acceptMinimalCookies() {
    const allCookiesList = this._getCurrentConfigAsJson();
    for (let i = 0; i < allCookiesList.length; i++) {
      if (!allCookiesList[i].immutable) {
        allCookiesList[i].accepted = false;
      }
    }
    convertToConfigFromStorage(
      JSON.stringify(allCookiesList),
      this.defaultCookieConfig
    );
    this.acceptCookies();
  }

  areAllCookiesAccepted() {
    const allCookiesList = this._getCurrentConfigAsJson();
    for (let i = 0; i < allCookiesList.length; i++) {
      if (!allCookiesList[i].accepted) {
        return false;
      }
    }
    return true;
  }

  isSomeCookieAccepted() {
    const cookieAccepted = getItem(COOKIE_PREFERENCES.COOKIE_ACCEPTED);
    return !cookieAccepted || cookieAccepted === false;
  }

  applyCookies() {
    const listOfCookies = this._getCurrentConfigAsJson();
    this.applyNextCookie(0, listOfCookies);
  }

  applyNextCookie(index, listOfCookies) {
    if (index < listOfCookies.length) {
      optInOut(listOfCookies[index]).then(() => {
        index++;
        this.applyNextCookie(index, listOfCookies);
      });
    }
  }

  acceptCookies() {
    setItem(
      COOKIE_PREFERENCES.COOKIE_SETTINGS,
      JSON.stringify(this._getCurrentConfigAsJson())
    );
    setItem(COOKIE_PREFERENCES.COOKIE_ACCEPTED, true);
    if (!sameObjects(this.initialConfig, this.cookieConfig)) {
      window.location.reload();
    } else {
      viewChannel.request("hide");
    }
  }

  appliedConfig() {
    return this.cookieConfig;
  }

  applyConfig(newConfig) {
    this.cookieConfig = newConfig;
  }

  toggleCategory(category, enabled) {
    toggleCategory(category, enabled);
    mainChannel.trigger("configUpdated");
  }

  toggleCookie(cookie, enabled) {
    cookie.accepted = enabled;
    mainChannel.trigger("configUpdated");
  }

  _getCurrentConfigAsJson() {
    return getConfigAsArrayJson(this.cookieConfig);
  }

  getCookieById(id) {
    const allCookies = this._getCurrentConfigAsJson();
    return getCookieById(allCookies, id);
  }

  acceptCookieById(id) {
    const allCookies = clone(this._getCurrentConfigAsJson());
    getCookieById(allCookies, id).accepted = true;
    convertToConfigFromStorage(
      JSON.stringify(allCookies),
      this.defaultCookieConfig
    );
    this.acceptCookies();
  }

  addCookieWatcher() {
    setInterval(() => {
      let actualCookies = listCookies();
      if (!sameObjects(this.cookies, actualCookies)) {
        this.cookies = actualCookies;
        console.log("Cookies changed", this.cookies);
      }
    }, 1500);
  }
}



// WEBPACK FOOTER //
// ./src-cookie-manager/managers/cookie-manager.js